<div class="header-main">
  @if (eyebrow()) {
    <p class="header-eyebrow">{{ eyebrow() }}</p>
  }
  @if (heading()) {
    @if (level() === 2) {
      <h2 class="header-heading">{{ heading() }}@if (count() !== null) {<span class="header-count"> ({{ count() }})</span>}</h2>
    } @else {
      <h1 class="header-heading">{{ heading() }}@if (count() !== null) {<span class="header-count"> ({{ count() }})</span>}</h1>
    }
  }
  <ng-content select=".header-title"></ng-content>
  @if (subtitle()) {
    <p class="header-subtitle">{{ subtitle() }}</p>
  }
</div>
<ng-content select=".header-actions"></ng-content>
<ng-content></ng-content>
